import React, { useState, useEffect } from "react";
import {
  Button,
  Typography,
  Grid,
  Container,
  Box,
  TextField,
  Paper,
  Table,
  TableBody,
  TableCell,
  TableContainer,
  TableHead,
  TableRow,
  Modal,
  FormControl,
  Select,
  MenuItem,
} from "@mui/material";
import api from "../globals/axios";
import { PARTNER_TYPES } from "../globals/values";
import CustomAppBar from "../components/AppBar";
import FarmerDetailsForm from "../components/FarmerDetailsForm";

export default function MyPartners() {
  const [partnerList, setPartnerList] = useState([]);
  const [addPartnerVisible, setAddPartnerVisible] = useState(false);
  const [updatePartnerVisible, setUpdatePartnerVisible] = useState(false);
  const [partnerType, setPartnerType] = useState();
  const [partnerEmail, setPartnerEmail] = useState();
  const [loading, setLoading] = useState(false);

  useEffect(() => {
    loadPartners();
  }, []);

  async function loadPartners() {
    const res = await api.get("/auth/get-partners");
    if (res.status === 200) {
      setPartnerList(res.data.partners);
    }
  }

  async function createPartner() {
    setLoading(true);
    const res = await api.post("/auth/add-partner", {
      partnerType: partnerType,
      partnerEmail: partnerEmail,
    });
    if (res.status === 200) {
      alert(res.data.message);
      setAddPartnerVisible(false);
    } else {
      alert("Error adding partner");
    }
    setLoading(false);
    window.location.reload();
  }

  return (
    <>
      <CustomAppBar />
      <Container maxWidth="xs">
        <div
          style={{
            // backgroundColor: theme.palette.background.paper,
            padding: 0.25,
            paddingLeft: 0.5,
            paddingRight: 0.5,
            flexGrow: 1,
          }}
        >
          <Grid
            container
            // spacing={1}
            justify="center"
            direction="column"
            style={{ marginTop: "10px" }}
          >
            <Typography variant="h5" mb={2}>
              My Partners
            </Typography>
            <TableContainer component={Paper}>
              <Table>
                <TableHead>
                  <TableRow>
                    <TableCell>Email</TableCell>
                    <TableCell align="right">Role</TableCell>
                    <TableCell align="right">Actions</TableCell>
                  </TableRow>
                </TableHead>
                <TableBody>
                  {partnerList.map((partner, index) => (
                    <TableRow key={index}>
                      <TableCell component="th" scope="row">
                        {partner.partner_email}
                      </TableCell>
                      <TableCell align="right">{partner.role}</TableCell>
                      <TableCell align="right">
                        <Button onClick={() => setUpdatePartnerVisible(true)}>
                          Update
                        </Button>
                      </TableCell>
                    </TableRow>
                  ))}
                </TableBody>
              </Table>
            </TableContainer>

            <Box>
              <Button onClick={() => setAddPartnerVisible(true)}>
                Add new Partner
              </Button>
            </Box>
          </Grid>
        </div>
        <Modal
          open={addPartnerVisible}
          onClose={() => setAddPartnerVisible(false)}
          aria-labelledby="modal-modal-title"
          aria-describedby="modal-modal-description"
        >
          <Box
            sx={{
              position: "absolute",
              top: "50%",
              left: "50%",
              transform: "translate(-50%, -50%)",
              backgroundColor: "white",
              // border: '2px solid #000',
              padding: 1,
              // width: '80%',
            }}
          >
            <Typography m={2} variant="h5">
              Add New Partner
            </Typography>
            <FormControl fullWidth>
              {/* <InputLabel id="token-select-label">Partner Type</InputLabel> */}
              <Select
                labelId="token-select-label"
                id="token-select"
                value={partnerType}
                onChange={(e) => {
                  setPartnerType(e.target.value);
                }}
              >
                {PARTNER_TYPES.map((b) => (
                  <MenuItem key={b.value} value={b.value}>
                    {b.label}
                  </MenuItem>
                ))}
              </Select>
              <TextField
                margin="normal"
                required
                fullWidth
                name="txtemail"
                label="Partner email to add"
                id="txtemail"
                value={partnerEmail}
                onChange={(event) => setPartnerEmail(event.target.value)}
              />
            </FormControl>
            <Button
              disabled={loading}
              variant="contained"
              onClick={createPartner}
            >
              Invite/Add
            </Button>
            <Button onClick={() => setAddPartnerVisible(false)}>Cancel</Button>
          </Box>
        </Modal>

        <Modal
          open={updatePartnerVisible}
          onClose={() => setUpdatePartnerVisible(false)}
          aria-labelledby="modal-modal-title"
          aria-describedby="modal-modal-description"
        >
          <Box
            sx={{
              position: "absolute",
              top: "50%",
              left: "50%",
              transform: "translate(-50%, -50%)",
              backgroundColor: "white",
              // border: '2px solid #000',
              padding: 2,
              borderRadius: 2,
              // width: '80%',
            }}
          >
            <Typography m={2} variant="h5">
              Update Partner Details
            </Typography>
            <FarmerDetailsForm />
            <Button
              disabled={loading}
              variant="contained"
              onClick={() => setUpdatePartnerVisible(false)}
            >
              Update
            </Button>
            <Button onClick={() => setUpdatePartnerVisible(false)}>
              Cancel
            </Button>
          </Box>
        </Modal>
      </Container>
    </>
  );
}
